import PropTypes from 'prop-types';
import { useMemo } from 'react';

import Select from '@Components/formsy/Select';
import Input from '@Components/formsy/Input';
import MaskedInput from '@Components/formsy/MaskedInput';

import { getValueOptions } from './utils';

const propTypes = {
  data: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
}

export default function Inputs({ data, options, onChange, disabled, name = "value-rule", props }) {
  const { key, equality, type, value } = data
  const { useLoadOptions, Component } = useMemo(() => options.find(option => option.value === key) || {}, [key, options])

  if (Component) {
    return <Component name={name} type={type} value={value}
      disabled={disabled} onChange={onChange} required {...props} />
  }

  if (['gender', 'fraud-score', 'action', 'boolean', 'weekday', 'day', 'month', 'year', 'state', 'country'].includes(type)) {
    return <Select name={name} value={value} options={getValueOptions(type)} clearable={false}
      onChange={option => onChange(option ? option.value : null)} disabled={disabled} required />
  }

  if (['allocation', 'publisher', 'offer', 'form', 'page'].includes(type)) {
    return <Select async name={name} value={value} options={useLoadOptions} clearable={false}
      onChange={option => onChange(option ? option.value : null)} disabled={disabled} required />
  }

  if (type === 'date') {
    return <Input required name={name} type='date' value={value}
      onChange={e => onChange(e.target.value)} disabled={disabled} />
  }

  if (type === 'time') {
    return <MaskedInput required name={name} className="form-control" value={value} disabled={disabled}
      mask={[/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]} onChange={e => onChange(e.target.value)} />
  }

  return <Input required name={name} value={value} onChange={onChange}
    type={type === 'integer' ? 'number' : 'text'} disabled={disabled} />
}

Inputs.propTypes = propTypes
Inputs.defaultProps = {}
